<template>
  <div class="bgimg pc" :style="bgimg" :class="topic">
  </div>
</template>

<script>
  export default {
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
        topic:sessionStorage.getItem('topic'),
        //有固定的bg图
        exportTopic:[{
          topic:'bulebusiness',
          img:require('@/assets/bulebusiness/backgroundImage.png'),
        },
        {
          topic:'newmediatemp',
          img:require('@/assets/newmediatemp/background.png'),
        },
        {
          topic:'purplebusiness',
          img:require('@/assets/purplebusiness/bg.6b5cbf57.png'),
        },
        {
          topic:'elevenpoll',
          img:require('@/assets/elevenpoll/background.cf0194a5.png'),
        }
        ],
      }
    },
    computed:{
      bgimg(){
        //有固定的bg图
        let result=this.exportTopic.find(item=>item.topic== this.topic)
        if(result){
          return {
            'background':`url(${result.img}) no-repeat center top/ 100% 100% `
          }
        }
        //可更换的背景图
        if(this.info.setting.backgroundImg){
          return {
            'background':`url(${this.info.setting.backgroundImg}) no-repeat center top/ 100% 100% `
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.bgimg{
  width: 10rem;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -10;
  &.pc{
    right: 0;
    margin:0 auto;
    width: 100%;
    max-width: 10rem;
    height: 100%;
  }
}
.pinkpolitics,
.orangepolitics,
.science,
.green,
.country,
.hotpot,
.civil,
.homestay,
.century,
.cartoon,
.bluetemp,
.morality,
.huaxian,
.cartoontaqin{
  display: none;
}
</style>